(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67],{

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://staging.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70710);













const VideoTestimonials = (props)=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial, secondVideoTestimonial)=>secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
    const videosCount = props.testimonialVideos?.length || 0;
    const videosSlidersettings = {
        infinite: videosCount > 3,
        arrows: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 1,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: videosCount > 2,
                    autoplay: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderDots),
                    infinite: videosCount > 1,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievements),
        style: {
            backgroundColor: props.sectionBgColor || "#ffffff",
            ...props?.parentContainerStyles ?? {}
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDiv),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                children: props.subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...videosSlidersettings,
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider),
                                ref: sliderRef,
                                children: limitedTestimonials?.length > 0 && limitedTestimonials?.map((content, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievementsDiv),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "33",
                                                    height: "22",
                                                    viewBox: "0 0 33 22",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                            fill: "#226CF5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                            fill: "#226CF5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().videoDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        iframeClassName: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().studVideo),
                                                        src: content.videoLink,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        children: content.name
                                                    }),
                                                    content?.designation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.designation
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.university
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            props.testimonialVideos?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoTestimonials);


/***/ }),

/***/ 42839:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrum":"SocialResponsibility_breadcrum__O586W","csrGlimpses":"SocialResponsibility_csrGlimpses__KDaYT","kcTrustAreas":"SocialResponsibility_kcTrustAreas__FQOej","csrIntiative":"SocialResponsibility_csrIntiative__fDLlW","courseFinder":"SocialResponsibility_courseFinder__Y3UAO","courseFinderContent":"SocialResponsibility_courseFinderContent__cYiB6","empoweringYouContent":"SocialResponsibility_empoweringYouContent__9i9pJ","empoweringYou":"SocialResponsibility_empoweringYou__x9hfP","socialResponsibility":"SocialResponsibility_socialResponsibility__SDs3f","heading":"SocialResponsibility_heading__ixwzj","buttongp":"SocialResponsibility_buttongp__EWYTo","kcbtn":"SocialResponsibility_kcbtn__eh2o8","centered":"SocialResponsibility_centered__x2kjI","breadcrumb-item":"SocialResponsibility_breadcrumb-item__M5LSS","active":"SocialResponsibility_active___7qfd","parentMainColumns":"SocialResponsibility_parentMainColumns__et0pr","parentMain":"SocialResponsibility_parentMain__xuayd","childa":"SocialResponsibility_childa__hvPZk","imgdiv":"SocialResponsibility_imgdiv__aiG_L","para":"SocialResponsibility_para__I5Hss","enquireBtn":"SocialResponsibility_enquireBtn__qi9Yv","totalBenefits":"SocialResponsibility_totalBenefits__EYttK","parentDiv":"SocialResponsibility_parentDiv__4DHBi","childDiv":"SocialResponsibility_childDiv__Jcyjm","title":"SocialResponsibility_title__4FZCN","benfitsPonits":"SocialResponsibility_benfitsPonits__V1gQU","child1":"SocialResponsibility_child1__20Wlh","content1":"SocialResponsibility_content1__5_SD6","area":"SocialResponsibility_area__J1BeO","content":"SocialResponsibility_content__45t0n","child2":"SocialResponsibility_child2__BQ2eg","content2":"SocialResponsibility_content2__IxJBr","child3":"SocialResponsibility_child3__tr3co","content3":"SocialResponsibility_content3__VHmfj","overlay":"SocialResponsibility_overlay__Fu2Nw","child3KcMihan":"SocialResponsibility_child3KcMihan__cRFlz","child4":"SocialResponsibility_child4__7Oocb","content4":"SocialResponsibility_content4__lBT2J","child5":"SocialResponsibility_child5__4x34r","content5":"SocialResponsibility_content5__LFCqz","tabs":"SocialResponsibility_tabs__qS88F","viewMore":"SocialResponsibility_viewMore___ICMn","techCabMarBott":"SocialResponsibility_techCabMarBott__HErLs","platformDivImg":"SocialResponsibility_platformDivImg__dZrad","contentDiv":"SocialResponsibility_contentDiv__tKRJc","platformDivImgMobile":"SocialResponsibility_platformDivImgMobile__eOiFi","areaContent":"SocialResponsibility_areaContent__c_Nzw","trustAreaPadding":"SocialResponsibility_trustAreaPadding__hksWm","trustAreaImg":"SocialResponsibility_trustAreaImg__PzkQj","EmpoweringYou":"SocialResponsibility_EmpoweringYou__iu8T9","gallery":"SocialResponsibility_gallery__o_een","images":"SocialResponsibility_images__NeS6h","sliderDiv":"SocialResponsibility_sliderDiv__tavup","galleryImages":"SocialResponsibility_galleryImages__c91w9","even":"SocialResponsibility_even__c4VZk","btcircle":"SocialResponsibility_btcircle__Eu4s8","testimonials":"SocialResponsibility_testimonials__srvg2","testimonialbg":"SocialResponsibility_testimonialbg__Fdrbg","cardBody":"SocialResponsibility_cardBody___OmAy","uptag":"SocialResponsibility_uptag__5Ys43","smalltext":"SocialResponsibility_smalltext__dVZH9","imgFixedBottom":"SocialResponsibility_imgFixedBottom__ch3eR","ceoTest":"SocialResponsibility_ceoTest__PMqtY","sliderDots":"SocialResponsibility_sliderDots__iC7Om","arrowDot":"SocialResponsibility_arrowDot__OrDaz","leftArrowContainer":"SocialResponsibility_leftArrowContainer__EwUAJ","rightArrowContainer":"SocialResponsibility_rightArrowContainer__VJ5e5","studentFooter":"SocialResponsibility_studentFooter__L7NeN","session":"SocialResponsibility_session__QCCNP","anchor":"SocialResponsibility_anchor__yQWGi","btTranparent":"SocialResponsibility_btTranparent__YnIkj","officeAddress":"SocialResponsibility_officeAddress__HHQ1F","showMap":"SocialResponsibility_showMap__NnPTc","offices":"SocialResponsibility_offices__LrJCQ","contactDetail":"SocialResponsibility_contactDetail__fMOnY","addDisplay":"SocialResponsibility_addDisplay__0zDxP","addImg":"SocialResponsibility_addImg__4mEZJ","imgl":"SocialResponsibility_imgl__RnH0n","map":"SocialResponsibility_map__4_6qt","mobileAnchor":"SocialResponsibility_mobileAnchor__addZb","row":"SocialResponsibility_row__TMpzJ","DesktopViewHeading":"SocialResponsibility_DesktopViewHeading__Nm90s","mobileHeading":"SocialResponsibility_mobileHeading__5WSBL","mobileCurve":"SocialResponsibility_mobileCurve___IBef"};

/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 49059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'CardHeaderContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 85509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47150);
/* harmony import */ var _restart_ui_Tabs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83916);
/* harmony import */ var _Nav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80957);
/* harmony import */ var _NavLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14691);
/* harmony import */ var _NavItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41244);
/* harmony import */ var _TabContent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28752);
/* harmony import */ var _TabPane__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75103);
/* harmony import */ var _ElementChildren__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53439);
/* harmony import */ var _getTabTransitionComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96101);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);












const defaultProps = {
  variant: 'tabs',
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  let defaultActiveKey;
  (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .forEach */ .Ed)(children, child => {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

function renderTab(child) {
  const {
    title,
    eventKey,
    disabled,
    tabClassName,
    tabAttrs,
    id
  } = child.props;

  if (title == null) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_NavItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    as: "li",
    role: "presentation",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_NavLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      as: "button",
      type: "button",
      eventKey: eventKey,
      disabled: disabled,
      id: id,
      className: tabClassName,
      ...tabAttrs,
      children: title
    })
  });
}

const Tabs = props => {
  const {
    id,
    onSelect,
    transition,
    mountOnEnter,
    unmountOnExit,
    children,
    activeKey = getDefaultActiveKey(children),
    ...controlledProps
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_1__/* .useUncontrolled */ .Ch)(props, {
    activeKey: 'onSelect'
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_restart_ui_Tabs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: (0,_getTabTransitionComponent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(transition),
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { ...controlledProps,
      role: "tablist",
      as: "ul",
      children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(children, renderTab)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TabContent__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(children, child => {
        const childProps = { ...child.props
        };
        delete childProps.title;
        delete childProps.disabled;
        delete childProps.tabClassName;
        delete childProps.tabAttrs;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TabPane__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { ...childProps
        });
      })
    })]
  });
};

Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';
/* harmony default export */ __webpack_exports__["Z"] = (Tabs);

/***/ })

}]);